import { createStore } from "zustand/vanilla";
import { Store } from "@/actions/schemas/stores";

type StoreWithWhatsAppEnabled = Store & {
  vitrine: Store["vitrine"];
};

export type VitrineState = {
  store: StoreWithWhatsAppEnabled;
  isOrdersEnabled: boolean;
};

export type VitrineStore = VitrineState;

export const createVitrineStore = (store: Store) => {
  const storeName = store.vitrine.name || store.name;
  const updatedStore = {
    ...store,
    name: storeName,
  };

  return createStore<VitrineStore>()(() => ({
    store: updatedStore,
    isOrdersEnabled: !!(
      store.vitrine.whatsAppSharingEnabled && store.vitrine.whatsAppNumber
    ),
  }));
};
